// einstieg in den präsentationsmodus, gehört zum hauptbundle der visualisierung (bericht wird nachgeladen)
// - zugang abfragen, anmeldung aus dem admintool übernehmen
// - ladebildschirm und KSL-logo
// - lädt SdgDesign.css, damit ladebildschirm und mindestbreite schon vor dem bericht gelten
import React, { Component } from "react";
import "./SdgDesign.css";

// zugang und anmeldung im präsentationsmodus
// - zugang: veröffentlichtes oder angefragtes berichtsjahr
// - nicht öffentliches jahr: anmeldung vom admintool übernehmen, das den tab geöffnet hat
// - antwort nur vom öffner und nur von der admin-adresse (REACT_APP_KSLPLUS_ADMIN_URL), sonst anmeldemaske

export const SDG_BEREIT = "kslplus-sdg-bereit";
export const SDG_ANMELDUNG = "kslplus-sdg-anmeldung";

export type SdgUebergabe = { token: string; refreshToken: string };

// antwort von GET api/sdg/praesentation-zugang: berichtsjahr, wählbare jahre (absteigend), öffentliche jahre
export type SdgZugang = { anmeldungNoetig: boolean; jahr?: number | null; jahre: number[]; oeffentlicheJahre: number[] };

// zugang abfragen; ziel "name=<kurzname>" (bürgerlink) oder "kunde=…&gemeinde=…" (vorschau)
// - ohne token aus sicht der bürger, ohne jahr gilt das veröffentlichte
export async function sdgZugangAbfragen(api: string, ziel: string, jahr: number, token: string): Promise<SdgZugang> {
    const r = await fetch(`${api}/api/sdg/praesentation-zugang?${ziel}${jahr > 0 ? "&jahr=" + jahr : ""}`,
        { headers: token ? { "Authorization": token } : {} });
    if (!r.ok) throw new Error("HTTP " + r.status);
    return await r.json();
}

// ursprung (schema, host, port) einer adresse; null bei fehlender oder ungültiger adresse
export function ursprung(url: string | undefined | null): string | null {
    if (!url) return null;
    try {
        return new URL(url).origin;
    } catch {
        return null;
    }
}

function oeffner(): Window | null {
    try {
        return window.opener && window.opener !== window ? window.opener as Window : null;
    } catch {
        return null;
    }
}

// anmeldung beim öffnenden admintool anfragen; null ohne gültige antwort in der wartezeit
export function sdgAnmeldungAnfordern(adminUrl: string | undefined, wartezeit: number = 3000): Promise<SdgUebergabe | null> {
    const admin = ursprung(adminUrl);
    const o = oeffner();
    if (!admin || !o) return Promise.resolve(null);
    return new Promise<SdgUebergabe | null>(resolve => {
        let fertig = false;
        let uhr = 0;
        let empfang: (e: MessageEvent) => void = () => { };
        const ende = (w: SdgUebergabe | null) => {
            if (fertig) return;
            fertig = true;
            window.removeEventListener("message", empfang);
            window.clearTimeout(uhr);
            resolve(w);
        };
        empfang = (e: MessageEvent) => {
            if (e.origin !== admin || e.source !== o) return;
            const d = e.data;
            if (d && d.typ === SDG_ANMELDUNG && typeof d.token === "string" && typeof d.refreshToken === "string" && d.token && d.refreshToken)
                ende({ token: d.token, refreshToken: d.refreshToken });
        };
        window.addEventListener("message", empfang);
        uhr = window.setTimeout(() => ende(null), wartezeit);
        try {
            o.postMessage({ typ: SDG_BEREIT }, admin);
        } catch {
            ende(null);
        }
    });
}

// KSL-logo als vektor (schriftzug und emblem aus assets/ksl-logo-animiert.svg) für kopf und ladebildschirm, größe per css-klasse

const LOGO: { farbe: string; d: string }[] = [
    { farbe: "#727272", d: "M 41.27 60.89 C 48.05 60.86 54.83 60.84 61.61 60.92 C 61.68 75.54 61.56 90.15 61.67 104.77 C 71.10 91.14 80.39 77.40 89.69 63.68 C 90.60 62.58 91.32 61.12 92.92 61.06 C 99.65 60.55 106.50 60.90 113.24 61.05 C 103.57 75.19 93.59 89.13 83.85 103.22 C 93.46 119.69 103.33 136.02 113.04 152.44 C 105.02 152.50 97.00 152.48 88.98 152.46 C 79.86 136.63 70.94 120.69 61.70 104.93 C 61.53 120.78 61.68 136.63 61.62 152.48 C 54.82 152.47 48.02 152.48 41.23 152.47 C 41.25 121.94 41.17 91.41 41.27 60.89 Z" },
    { farbe: "#00979f", d: "M 176.11 61.97 C 182.48 64.77 187.05 69.62 190.97 75.24 C 186.11 78.78 181.18 82.21 176.30 85.72 C 173.07 81.92 170.03 78.26 165.08 76.71 C 161.83 75.89 158.16 75.81 154.91 76.64 C 151.13 77.88 149.21 82.12 150.23 85.87 C 151.19 89.78 154.78 92.15 158.13 93.91 C 165.89 97.73 175.39 100.47 182.57 105.42 C 192.31 112.16 195.60 125.82 191.72 136.72 C 188.53 146.52 179.03 153.39 169.02 154.79 C 160.41 156.15 150.68 155.32 142.95 151.02 C 136.73 147.76 132.28 142.68 128.36 136.97 C 133.63 133.21 138.92 129.49 144.20 125.74 C 147.01 129.78 149.93 134.18 154.45 136.48 C 159.45 139.03 166.00 139.17 170.50 135.53 C 174.26 132.41 174.28 126.30 171.42 122.60 C 169.09 119.71 165.63 118.12 162.29 116.70 C 155.47 113.92 148.07 111.20 141.92 107.11 C 134.64 102.25 130.20 93.78 130.54 85.00 C 130.54 75.97 135.24 67.59 143.11 63.10 C 153.01 57.54 165.80 57.30 176.11 61.97 Z" },
    { farbe: "#727272", d: "M 211.85 61.12 C 218.72 60.71 225.54 60.89 232.42 60.87 C 232.48 85.45 232.43 110.03 232.44 134.62 C 247.24 134.62 262.04 134.62 276.83 134.61 C 276.86 140.54 276.86 146.46 276.83 152.39 C 255.17 152.36 233.51 152.42 211.84 152.36 C 211.84 121.95 211.83 91.53 211.85 61.12 Z" },
    { farbe: "#00979f", d: "M 337.64 26.25 C 357.59 25.72 377.83 35.12 391.03 49.99 C 402.78 62.95 409.38 80.28 409.40 97.75 C 407.44 97.74 405.48 97.72 403.51 97.70 C 393.83 97.63 384.14 97.66 374.46 97.69 C 374.46 94.97 374.45 92.26 374.45 89.54 C 365.07 89.45 355.64 89.74 346.27 89.45 C 345.50 87.98 345.77 86.58 345.72 84.98 C 345.84 76.93 345.78 68.87 345.76 60.81 C 343.03 60.81 340.29 60.80 337.56 60.81 C 337.60 55.20 337.60 49.60 337.53 43.99 C 337.57 38.09 337.25 32.14 337.64 26.25 Z" },
    { farbe: "#b9b9b8", d: "M 337.53 43.99 C 337.60 49.60 337.60 55.20 337.56 60.81 C 334.79 60.82 332.02 60.84 329.26 60.87 C 329.16 70.44 329.34 80.01 329.14 89.59 C 319.63 89.56 310.11 89.59 300.60 89.56 C 300.57 92.32 300.53 95.09 300.52 97.85 C 294.83 97.85 289.15 97.78 283.46 97.62 C 283.75 80.79 291.86 64.48 305.55 54.57 C 314.77 47.66 326.02 44.07 337.53 43.99 Z" },
    { farbe: "#9dcad1", d: "M 277.40 97.50 C 279.42 97.54 281.44 97.58 283.46 97.62 C 289.15 97.78 294.83 97.85 300.52 97.85 C 300.51 100.57 300.52 103.29 300.52 106.01 C 310.08 106.36 319.64 106.09 329.21 106.20 C 329.27 115.71 329.21 125.22 329.24 134.74 C 332.01 134.74 334.78 134.74 337.55 134.74 C 337.54 142.38 337.59 150.01 337.51 157.65 C 318.36 157.82 299.62 148.06 288.64 132.40 C 281.31 122.27 277.56 109.97 277.40 97.50 Z" },
    { farbe: "#727272", d: "M 374.46 97.69 C 384.14 97.66 393.83 97.63 403.51 97.70 C 403.18 114.54 396.91 130.98 385.13 143.12 C 372.86 156.14 355.34 163.53 337.48 163.61 C 337.49 161.62 337.50 159.64 337.51 157.65 C 337.59 150.01 337.54 142.38 337.55 134.74 C 340.29 134.74 343.03 134.74 345.76 134.74 C 345.77 125.22 345.76 115.71 345.77 106.19 C 355.32 106.17 364.87 106.18 374.42 106.18 C 374.44 103.35 374.46 100.52 374.46 97.69 Z" },
    { farbe: "#ffffff", d: "M 329.26 60.87 C 332.02 60.84 334.79 60.82 337.56 60.81 C 340.29 60.80 343.03 60.81 345.76 60.81 C 345.78 68.87 345.84 76.93 345.72 84.98 C 345.77 86.58 345.50 87.98 346.27 89.45 C 355.64 89.74 365.07 89.45 374.45 89.54 C 374.45 92.26 374.46 94.97 374.46 97.69 C 374.46 100.52 374.44 103.35 374.42 106.18 C 364.87 106.18 355.32 106.17 345.77 106.19 C 345.76 115.71 345.77 125.22 345.76 134.74 C 343.03 134.74 340.29 134.74 337.55 134.74 C 334.78 134.74 332.01 134.74 329.24 134.74 C 329.21 125.22 329.27 115.71 329.21 106.20 C 319.64 106.09 310.08 106.36 300.52 106.01 C 300.52 103.29 300.51 100.57 300.52 97.85 C 300.53 95.09 300.57 92.32 300.60 89.56 C 310.11 89.59 319.63 89.56 329.14 89.59 C 329.34 80.01 329.16 70.44 329.26 60.87 Z" }
];

export const SdgKslLogo = (props: { className?: string }) => (
    <svg className={props.className} viewBox="36 20 382 150" role="img" aria-label="KSLplus">
        {LOGO.map((s, i) => <path key={i} fill={s.farbe} d={s.d} />)}
    </svg>
);

// ladebildschirm des präsentationsmodus
// - KSL-logo, „SDG / Nachhaltigkeit · wird geladen …“, dahinter blasses SDG-rad als wasserzeichen
// - deckt die seite, bis der bericht geladen ist, mindestens 2,7 s, dann ausblenden

// 17 zielfarben als ring (innenradius 66, außenradius 112, im uhrzeigersinn ab 12 uhr)
const RING: { farbe: string; d: string }[] = [
    { farbe: "#E5243B", d: "M100.77 9.66A112 112 0 0 1 139.23 9.66L131.33 54.98A66 66 0 0 0 108.67 54.98Z" },
    { farbe: "#DDA63A", d: "M141.92 10.17A112 112 0 0 1 177.79 24.06L154.06 63.47A66 66 0 0 0 132.92 55.28Z" },
    { farbe: "#4C9F38", d: "M180.12 25.50A112 112 0 0 1 208.55 51.42L172.18 79.59A66 66 0 0 0 155.43 64.31Z" },
    { farbe: "#C5192D", d: "M210.20 53.60A112 112 0 0 1 227.34 88.04L183.26 101.16A66 66 0 0 0 173.15 80.87Z" },
    { farbe: "#FF3A21", d: "M228.09 90.67A112 112 0 0 1 231.64 128.97L185.79 125.29A66 66 0 0 0 183.70 102.72Z" },
    { farbe: "#26BDE2", d: "M231.39 131.70A112 112 0 0 1 220.86 168.69L179.44 148.69A66 66 0 0 0 185.64 126.89Z" },
    { farbe: "#FCC30B", d: "M219.64 171.14A112 112 0 0 1 196.46 201.84L165.06 168.23A66 66 0 0 0 178.72 150.14Z" },
    { farbe: "#A21942", d: "M194.44 203.68A112 112 0 0 1 161.73 223.93L144.59 181.25A66 66 0 0 0 163.86 169.31Z" },
    { farbe: "#FD6925", d: "M159.18 224.92A112 112 0 0 1 121.37 231.99L120.81 186.00A66 66 0 0 0 143.09 181.83Z" },
    { farbe: "#DD1367", d: "M118.63 231.99A112 112 0 0 1 80.82 224.92L96.91 181.83A66 66 0 0 0 119.19 186.00Z" },
    { farbe: "#FD9D24", d: "M78.27 223.93A112 112 0 0 1 45.56 203.68L76.14 169.31A66 66 0 0 0 95.41 181.25Z" },
    { farbe: "#BF8B2E", d: "M43.54 201.84A112 112 0 0 1 20.36 171.14L61.28 150.14A66 66 0 0 0 74.94 168.23Z" },
    { farbe: "#3F7E44", d: "M19.14 168.69A112 112 0 0 1 8.61 131.70L54.36 126.89A66 66 0 0 0 60.56 148.69Z" },
    { farbe: "#0A97D9", d: "M8.36 128.97A112 112 0 0 1 11.91 90.67L56.30 102.72A66 66 0 0 0 54.21 125.29Z" },
    { farbe: "#56C02B", d: "M12.66 88.04A112 112 0 0 1 29.80 53.60L66.85 80.87A66 66 0 0 0 56.74 101.16Z" },
    { farbe: "#00689D", d: "M31.45 51.42A112 112 0 0 1 59.88 25.50L84.57 64.31A66 66 0 0 0 67.82 79.59Z" },
    { farbe: "#19486A", d: "M62.21 24.06A112 112 0 0 1 98.08 10.17L107.08 55.28A66 66 0 0 0 85.94 63.47Z" }
];

// mindestdauer in ms ab dem erscheinen; lädt der bericht länger, bleibt er bis dahin
const MINDESTENS = 2700;

type Props = {
    // bericht geladen: ausblenden
    fertig: boolean;
};

type State = {
    ausblenden: boolean;
    weg: boolean;
};

export class SdgLadeschirm extends Component<Props, State> {
    state: State = { ausblenden: false, weg: false };
    private _start = Date.now();
    private _uhren: number[] = [];

    componentDidMount() {
        if (this.props.fertig) this.beenden();
    }

    componentDidUpdate(prev: Props) {
        if (this.props.fertig && !prev.fertig) this.beenden();
    }

    componentWillUnmount() {
        this._uhren.forEach(u => window.clearTimeout(u));
    }

    // nach der mindestdauer ausblenden (.45 s übergang), danach nichts mehr zeichnen
    private beenden() {
        const rest = Math.max(0, MINDESTENS - (Date.now() - this._start));
        this._uhren.push(window.setTimeout(() => {
            this.setState({ ausblenden: true });
            this._uhren.push(window.setTimeout(() => this.setState({ weg: true }), 450));
        }, rest));
    }

    render() {
        if (this.state.weg) return null;
        return (
            <div className={"sdg-laden" + (this.state.ausblenden ? " ist-fertig" : "")} role="status" aria-live="polite">
                <svg className="sdg-laden-rad" viewBox="0 0 240 240" aria-hidden="true">
                    {RING.map((s, i) => <path key={i} fill={s.farbe} d={s.d} />)}
                </svg>
                <div className="sdg-laden-inhalt">
                    <SdgKslLogo className="sdg-laden-logo" />
                    <div className="sdg-laden-text">
                        <div className="sdg-laden-titel">SDG / Nachhaltigkeit</div>
                        <div className="sdg-laden-status">wird geladen<span className="sdg-laden-punkte"><span>.</span><span>.</span><span>.</span></span></div>
                    </div>
                </div>
            </div>
        );
    }
}
